import { handleActions } from 'redux-actions';
import _ from 'lodash';

import { fetchStepsDataSuccess, StepChangeNext, StepChangePrev } from '../actions/actions';

export const stepsReducer = handleActions(
	{
		[fetchStepsDataSuccess](state, { payload: data }) {
			var screens =  _.filter(data.steps, function(step) {
				if (step.has_own_step) return step;
			});

			return {
				currentStep : state.currentStep,
				totalSteps : screens.length,
				stepsInfo : data.steps,
				buttonNextText: data.steps[state.currentStep].button_next_text
			};
		},
		[StepChangeNext](state, {}) {
			return Object.assign({}, state, {
				currentStep: state.currentStep < state.totalSteps ? state.currentStep + 1 : state.currentStep,
				buttonNextText: state.stepsInfo[state.currentStep + 1].button_next_text
			});
		},
		[StepChangePrev](state, {}) {
			return Object.assign({}, state, {
				currentStep: state.currentStep > 1 ? state.currentStep - 1 : state.currentStep,
				buttonNextText: state.currentStep > 1 ? state.stepsInfo[state.currentStep - 1].button_next_text : state.currentStep
			});
		},
	},
	{
		currentStep : 0,
		totalSteps : null,
		stepsInfo : {},
		buttonNextText : 'Continue'
	}
);
